import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {
  s,
  colors,
  alpha,
  sAbsoluteMax,
  sDesc,
  sText,
  sTextGradient,
} from '../style'
import H from './H'
import alt from '../content/alt'

const ImageSection = ({
  h,
  s,
  title,
  desc,
  image,
  html,
  noeffect,
  children,
}) => {
  return (
    <div css={sContainer}>
      <div css={sTextContainer}>
        <H h={h} css={[sTextGradient, sText[s || h || 2]]}>
          {title}
        </H>
        {desc && (
          <div
            dangerouslySetInnerHTML={{ __html: desc }}
            css={[sDesc, sLi, html && sHtml]}
          />
        )}
        {children}
      </div>
      <div css={sImageContainer}>
        <GatsbyImage
          image={getImage(image)}
          imgStyle={{ borderRadius: '2rem' }}
          css={{ borderRadius: '2rem' }}
          alt={title + alt}
        />
        {!noeffect && <div css={sEffect1} />}
        {!noeffect && <div css={sEffect1} />}
        {!noeffect && <div css={sEffect2} />}
      </div>
    </div>
  )
}

const sContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '8rem',
  [s.sm_down]: {
    marginTop: '6rem',
    flexDirection: 'column',
  },
}

const sTextContainer = {
  flexBasis: '50%',
  maxWidth: '50%',
  paddingRight: '2rem',
  [s.sm_down]: {
    flexBasis: '100%',
    maxWidth: '100%',
    paddingRight: 0,
    paddingBottom: '3rem',
  },
}

const sImageContainer = {
  flexBasis: '50%',
  maxWidth: '50%',
  marginLeft: '4rem',
  [s.sm_down]: {
    flexBasis: '100%',
    maxWidth: '100%',
    margin: 0,
  },
  position: 'relative',
  top: 0,
  left: 0,
  height: 'max-content',
}

const sAbsolute = {
  ...sAbsoluteMax,
  borderRadius: '2rem',
}

const sEffect1 = {
  ...sAbsolute,
  zIndex: 1,
  background: `linear-gradient(to right,
    ${colors.brandDarker},
    ${colors.brand.concat(alpha[0])}
  )`,
  mixBlendMode: 'soft-light',
}

const sEffect2 = {
  ...sAbsolute,
  zIndex: 1,
  background: `linear-gradient(to top right,
    ${colors.brandDarker},
    ${colors.brand.concat(alpha[0])}
  )`,
  mixBlendMode: 'overlay',
}

const sHtml = {
  fontSize: '1rem',
  p: {
    marginBottom: '1rem',
  },
  li: {
    marginLeft: '2rem',
  },
}

const sLi = {
  li: {
    marginLeft: '2rem',
  },
}

export default ImageSection
